enum KC_Colors {
  Red,
  Blue,
  Green,
  Grey,
  LightGrey,
  Black,
  Green_two,
  Error
}

export const KC_RED = "#EA357F";

export default KC_Colors;
